import createFetchTypes from '@app/utils/createFetchTypes';
import axios from '@global/axios';
import { apiUrl } from '@app/constants';
import { fetchAction } from '../types';
import { FilterOptions } from '@app/types';
import { CtaHiddenUpdate } from '../cta/types';

const mainType = 'FUNNEL';

export const getFunnelsTypes = createFetchTypes(`${mainType}_GET_FUNNELS`);

function getFunnels(filterOptions?: FilterOptions): fetchAction {
	const defaultFilter = {
		pagination: { page: 1, pageSize: 20 },
		filter: [{ field: 'active', value: true }],
		populate: [
			{
				field: 'campaigns',
				select: [
					'state',
					'name',
					'id',
					'contactCount',
					'contacts',
					'callToActions',
					'milestone',
					'milestoneEntryTerm',
					'nicheCorePlan',
					'onboardingFormOnly',
					'entryTerm',
					'createdAt',
					'launchedAt',
					'personalization',
					'creationMethod',
					'audience',
					'permanentlyDisabled',
				],
				populate: [
					{
						field: 'callToActions',
						select: [],
					},
					{
						field: 'nicheInboxMessageContent',
						select: [],
					},
				],
			},
		],
	};

	const filterString = filterOptions
		? JSON.stringify({ ...defaultFilter, ...filterOptions })
		: JSON.stringify(defaultFilter);

	return {
		type: getFunnelsTypes,
		callAPI: () =>
			axios.get(
				`${apiUrl}/funnels${filterString ? `?filter=${filterString}` : ''}`,
			),
	};
}

export const getFunnelTypes = createFetchTypes(`${mainType}_GET_FUNNEL_BY_ID`);

function getFunnel(funnelId: string): fetchAction {
	return {
		type: getFunnelTypes,
		callAPI: () => axios.get(`${apiUrl}/funnels/${funnelId}`),
	};
}

function updateFunnelCampaignCTA(payload: {
	funnelId: string;
	campaignId: string;
	ctaId: string;
	messageType: 'dueDateNudge';
	text: string;
}) {
	return {
		type: 'funnel/UPDATE_FUNNEL_CAMPAIGN_CTA',
		payload,
	};
}

function updateFunnelCampaignCTAHidden(payload: {
	funnelId: string;
	campaignId: string;
	updates: CtaHiddenUpdate[];
}) {
	return {
		type: 'funnel/UPDATE_FUNNEL_CAMPAIGN_CTA_HIDDEN',
		payload,
	};
}

function updateFunnelCampaignNicheInboxContentText(payload: {
	funnelId: string;
	campaignId: string;
	text: string;
}) {
	return {
		type: 'funnel/UPDATE_FUNNEL_CAMPAIGN_NICHE_INBOX_CONTENT_TEXT',
		payload,
	};
}

export {
	getFunnels,
	getFunnel,
	updateFunnelCampaignCTA,
	updateFunnelCampaignCTAHidden,
	updateFunnelCampaignNicheInboxContentText,
};
